import React from "react";
import DatePicker from "react-datepicker";
import DateHelper from "../DateHelper/DateHelper";

export default class TimePickerInput extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var offsetTime = true
    if (this.props.offsetTime != undefined) {
      offsetTime = this.props.offsetTime
    }
    return (
      <div className="time-picker-input">
        <div
          className={
            "input-group time-picker-input-wrapper" + this.props.className
          }
        >
          <DatePicker
            className={
              this.props.classNames
                ? `${this.props.classNames} form-control`
                : "form-control"
            }
            selected={
              this.props.selectedTime
                ? DateHelper.parseDate(this.props.selectedTime, offsetTime)
                : null
            }
            showPopperArrow={false}
            onChange={this.handleChange}
            dateFormat={DateHelper.rubyToDateFNS(this.props.format)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={this.props.timeInvervals || 10}
          />
        </div>
      </div>
    );
  }

  handleChange = (time) => {
    var offsetTime = true
    if (this.props.offsetTime != undefined) {
      offsetTime = this.props.offsetTime
    }

    if (offsetTime) {
      time = DateHelper.reverseOffset(time)
    }
    if (this.props.customChangeSource === "EmailCampaigns") {
      this.props.customChangeHandler(time, this.props.field);
    } else if (this.props.customChangesource === "DatatableSearch") {
      this.props.customChangeHandler(time, this.props.name);
    } else {
      this.props.onChange(time)
    }
  };
}
